import React, { memo, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import VideoLoadingThumb from 'Assets/layout/profile/video-loading.png';
import ImageBroken from 'Assets/layout/profile/image-broken.png';

import { SliderMediaType } from '../types';

import './SliderPreviewItem.scss';

interface SliderPreviewItemProps {
  type: string;
  src: string;
  alt?: string;
  size: 'medium' | 'large';
}

const MEDIA_THUMBS = {
  [SliderMediaType.VIDEO]: VideoLoadingThumb,
  [SliderMediaType.IMAGE]: ImageBroken
};

export const SliderPreviewItem = ({ type, src, alt, size }: SliderPreviewItemProps) => {

  const thumbSrc = src ?? MEDIA_THUMBS[type];

  return (
    <div style={{ backgroundImage: `url(${thumbSrc})` }}
         aria-label={alt}
         styleName={classNames('preview-item preview-item--image', {
          'preview-item--size-medium': size === 'medium',
          'preview-item--size-large': size === 'large'})}
    >
      { type === SliderMediaType.VIDEO &&
        <>
          <div styleName="preview-item__backdrop" />
          <div styleName="preview-item__play-button" className="dashicon dashicon-play-circle" />
        </>
      }
    </div>
  );
};

export default memo(SliderPreviewItem);
